export function getIsPrerenderUserAgent() {
  return navigator != null && /prerender/i.test(navigator.userAgent);
}
export function getIsEcosystemSocialScreenshotUserAgent() {
  return navigator != null && /Ecosystem-Social-Screenshot/.test(navigator.userAgent);
}
export function getIsChromeUserAgent() {
  return navigator != null && /chrome/i.test(navigator.userAgent);
}